// extracted by mini-css-extract-plugin
export var avatarContainer = "_e9-0";
export var avatarTypingWave = "_e9-i";
export var gray = "_e9-f";
export var green = "_e9-c";
export var icon = "_e9-9";
export var image = "_e9-1";
export var lg = "_e9-6";
export var md = "_e9-5";
export var presenceDot = "_e9-b";
export var red = "_e9-d";
export var sm = "_e9-4";
export var status = "_e9-a";
export var typingDot = "_e9-h";
export var typingPill = "_e9-g";
export var xl = "_e9-7";
export var xs = "_e9-3";
export var xxl = "_e9-8";
export var xxs = "_e9-2";
export var yellow = "_e9-e";